
document.querySelectorAll(".product_compatible_accessories_bottom_right").forEach(button => {
  button.addEventListener("click", function() {
    this.classList.toggle("show_more");
    const accessoryList = this.closest(".product_compatible_accessories_block")
                              .querySelector(".product_compatible_accessories_list")
                              .querySelectorAll(".product_compatible_accessorie_more");
    accessoryList.forEach(accessory=>{
    accessory.classList.toggle("hide");
      
    })
  });
});

document.querySelectorAll(".pro_variant_radio").forEach(radio => {
  radio.addEventListener("change", function() {
    const checkboxInput = this.closest(".product_compatible_accessorie")
                             .querySelector(".product_compatible_accessorie_checkbox input");
    checkboxInput.value = this.value;
  });
});

document.querySelectorAll(".compatible_accessorie_checkbox").forEach(checkbox => {
  checkbox.addEventListener("change", function(event) {
    const isChecked = event.target.checked;
    const overlay = this.closest(".product_compatible_accessorie")
                        .querySelector(".product_compatible_accessorie_overlay");

    if (isChecked) {
      overlay.classList.add("product_compatible_accessorie_overlay_show");
      setTimeout(() => {
        overlay.classList.remove("product_compatible_accessorie_overlay_show");
      }, 2000);
    } else {
      overlay.classList.remove("product_compatible_accessorie_overlay_show");
    }

    const selectedCheckboxes = document.querySelectorAll(".compatible_accessorie_checkbox:checked");
 
    const selectedCount = selectedCheckboxes.length;
    const bottomLeftElement = document.querySelector(".product_compatible_accessories_bottom_left");

    if (selectedCount > 0) {
        let totalPrice = 0
           selectedCheckboxes.forEach((checkbox) => {
             totalPrice += checkbox.getAttribute("data-price")*1
            });
         let discount_price = totalPrice * 0.1
       bottomLeftElement.innerHTML = `<span style="color:rgb(var(--color-sale-off-price));">Already Saved <strong>${Shopify.formatMoney(discount_price)}</strong> ！</span>`;
    
    } else {
      bottomLeftElement.innerHTML = "Buy More Save More";
    }
  });
});
// new shop 优化
// 视频区域动画
 document.addEventListener("DOMContentLoaded", function () {
  // 移动端不执行动画，直接填充文本
  if (window.innerWidth <= 900) {
    document.querySelectorAll(".new-shop-video-title, .new-shop-video-subtitle").forEach(function(line){
      line.innerHTML = line.getAttribute("data-text") || "";
    });
    return;
  }
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined")
    return;
  const videoSection = document.querySelectorAll(".new-shop-video-section");
  if (!videoSection || videoSection.length === 0) return;
  videoSection.forEach((section) => {
    const title = section.querySelector(".new-shop-video-title");
    const subtitle = section.querySelector(".new-shop-video-subtitle");

    // 直接填充文字内容
    title.innerHTML = title.getAttribute("data-text") || "";
    subtitle.innerHTML = subtitle.getAttribute("data-text") || "";

    const mask = section.querySelector(".new-shop-video-mask");
    const content = section.querySelector(".new-shop-video-content");
    const delayPx = window.innerHeight * 1;
    const scrollLength = window.innerHeight * 1;
    const totalLength = delayPx + scrollLength;
    mask.style.transform = "translateY(100%)";
    
    // 初始显示内容
    content.style.display = "none";

    ScrollTrigger.create({
      trigger: section,
      start: `bottom bottom`,
      end: `bottom+=${totalLength} bottom`,
      pin: true,
      scrub: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      fastScrollEnd: true,
      fastScrollEndDelay: 0.1,
      onUpdate: (self) => {
        const progress = self.progress; // 0~1

        let maskProgress =
          Math.min(progress, delayPx / totalLength) / (delayPx / totalLength);
        maskProgress = Math.max(0, Math.min(1, maskProgress));
        mask.style.transform = `translateY(${100 - 100 * maskProgress}%)`;

        // 蒙层未到80%时隐藏内容
        if (maskProgress < 0.8) {
          content.style.display = "none";
        } else {
          content.style.display = "flex";
        }
      },
    });
    window.addEventListener("resize", () => ScrollTrigger.refresh());
  });
});

// logo banner
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.logo-marquee').forEach(function(marqueeBox) {
    const marqueeTrack = marqueeBox.querySelector('.logo-marquee-track');
    let speed = 2;
    let slowSpeed = 1;
    let currentSpeed = speed;
    let pos = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartPos = 0;
    let trackWidth = marqueeTrack.scrollWidth / 2;
    let animationId = null;
    let dragMoved = false;

    // 自动滚动
    function animate() {
      if (!isDragging) {
        pos -= currentSpeed;
        if (pos <= -trackWidth) pos += trackWidth;
        if (pos > 0) pos -= trackWidth;
        marqueeTrack.style.transform = `translateX(${pos}px)`;
      }
      animationId = requestAnimationFrame(animate);
    }
    animate();

    // 鼠标移入减速
    marqueeBox.addEventListener('mouseenter', function() {
      currentSpeed = slowSpeed;
    });
    marqueeBox.addEventListener('mouseleave', function() {
      currentSpeed = speed;
    });

    // 拖动
    function onDragStart(e) {
      isDragging = true;
      dragMoved = false;
      dragStartX = (e.touches ? e.touches[0].clientX : e.clientX);
      dragStartPos = pos;
      marqueeTrack.style.cursor = 'grabbing';
    }
    function onDragMove(e) {
      if (!isDragging) return;
      let clientX = (e.touches ? e.touches[0].clientX : e.clientX);
      let dx = clientX - dragStartX;
      if (Math.abs(dx) > 5) dragMoved = true; // 超过5px才算拖动
      pos = dragStartPos + dx;
      if (pos <= -trackWidth) pos += trackWidth;
      if (pos > 0) pos -= trackWidth;
      marqueeTrack.style.transform = `translateX(${pos}px)`;
    }
    function onDragEnd() {
      isDragging = false;
      marqueeTrack.style.cursor = '';
      setTimeout(() => { dragMoved = false; }, 100); // 拖动后100ms内禁止点击
    }

    marqueeBox.addEventListener('mousedown', onDragStart);
    marqueeBox.addEventListener('touchstart', onDragStart);
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchend', onDragEnd);

    // 拖动时禁止点击
    marqueeBox.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function(e) {
        if (isDragging || dragMoved) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });
    });

    // 防止拖拽选中文字
    marqueeBox.addEventListener('dragstart', e => e.preventDefault());
  });
});
function initBestSellerSection(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) {
    console.warn("Best Seller section not found:", sectionId);
    return;
  }
  
  // 防止重复初始化
  if (section.dataset.initialized === "true") {
    return;
  }
  
  try {
    // 初始化标签页切换
    const tabs = section.querySelectorAll(".new-shop-best-seller-tab");
    const panels = section.querySelectorAll(".new-shop-best-seller-panel");
  
    tabs.forEach((tab, idx) => {
      tab.addEventListener("click", function () {
        tabs.forEach((t) => t.classList.remove("active"));
        panels.forEach((p) => p.classList.remove("active"));
        tab.classList.add("active");
        panels[idx].classList.add("active");
        setTimeout(() => {
          panels[idx].querySelectorAll(".swiper-slide").forEach((slide) => {
            slide.classList.remove("fade-in-up");
            void slide.offsetWidth;
            slide.classList.add("fade-in-up");
          });
        }, 10);
      });
    });
    // 初始化主轮播
    section.querySelectorAll('.new-shop-best-seller-panel-swiper').forEach(function (swiperEl, idx) {
      if (swiperEl.swiper) {
        swiperEl.swiper.destroy();
      }
      
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 24,
        autoHeight: false,
        navigation: {
          nextEl: '.new-shop-best-seller-panel-swiper-next-' + idx,
          prevEl: '.new-shop-best-seller-panel-swiper-prev-' + idx,
        },
        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          600: {
            slidesPerView: 3,
            spaceBetween: 12
          },
          500: {
              slidesPerView: 1.5,
            spaceBetween: 12
          },
          400: {
            slidesPerView: 'auto',
            spaceBetween: 12
          },
          0: {
            slidesPerView: 'auto',
            spaceBetween: 12
          }
        },
        loop: false,
        on: {
          init: function() {
            updateNavigationButtons(this);
          },
          slideChange: function() {
            updateNavigationButtons(this);
          },
          resize: function() {
            updateNavigationButtons(this);
          }
        }
      });
      
      // 更新导航按钮显示状态的函数
      function updateNavigationButtons(swiperInstance) {
        const prevBtn = swiperInstance.el.querySelector('.swiper-button-prev');
        const nextBtn = swiperInstance.el.querySelector('.swiper-button-next');
        
        if (prevBtn) {
          prevBtn.style.display = swiperInstance.isBeginning ? 'none' : 'flex';
        }
        if (nextBtn) {
          nextBtn.style.display = swiperInstance.isEnd ? 'none' : 'flex';
        }
      }
    });
  
    // 标记为已初始化
    section.dataset.initialized = "true";
  } catch (error) {
    console.error("Error initializing Best Seller section:", sectionId, error);
  }
  }
  
  // 页面加载完成后初始化所有Best Seller模块
  document.addEventListener("DOMContentLoaded", function () {
  // 查找所有Best Seller模块并初始化
  const bestSellerSections = document.querySelectorAll(".new-shop-best-seller");
  bestSellerSections.forEach(function (section) {
    const sectionId = section.id;
    if (sectionId) {
      initBestSellerSection(sectionId);
    }
  });
  });
  
  // 监听Shopify主题编辑器的事件
  document.addEventListener("shopify:section:load", function (event) {
  if (event.target.classList.contains("new-shop-best-seller")) {
    const sectionId = event.target.id;
    if (sectionId) {
      initBestSellerSection(sectionId);
    }
  }
  });